import {LIMIT_LOTTERY} from "./types";

const init = {
    isLoading: false,
    list: [],
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case LIMIT_LOTTERY:
            return {
                ...state,
                list: payload,
                isLoading: false
            };
        default:
            return state;
    }
}
